import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useDeviceStatus } from "Components/Dashboard/queries";
import { useAppSelector } from "store/hook";

const { Option } = Select;

interface FieldFilterProps {
  selectedCid?: string;
  filter: Record<string, string[]>;
  setFilter: (arg: FieldFilterProps["filter"]) => void;
}

const FiledFilter = ({ selectedCid, filter, setFilter }: FieldFilterProps) => {
  const { level, stateCid, loginCid } = useAppSelector((status) => status.global);

  const { t } = useTranslation();

  const onValuesChange = (value: any) => {
    setFilter({ ...filter, ...value });
  };

  // group 列表必須依照客戶顯示
  const cid = stateCid !== "" ? stateCid : selectedCid !== "" ? selectedCid : "";

  // @ts-ignore
  const { data: deviceStatus } = useDeviceStatus(level, cid, loginCid);
  const groups = deviceStatus?.response?.groups || [];
  const models = deviceStatus?.response?.models || [];
  const locations = deviceStatus?.response?.locations || [];

  return (
    <div className="formwrap" style={{ width: "380px", padding: "5px" }}>
      <Form onValuesChange={onValuesChange} layout="vertical">
        {/* <Form.Item label={t("ISMS.Model")} name="model">
          <Select mode="multiple" placeholder={t("ISMS.Select")} maxTagCount={"responsive"}>
            {models.map((model) => (
              <Option key={model} value={model}>
                {model}
              </Option>
            ))}
          </Select>
        </Form.Item> */}

        <Form.Item label={t("ISMS.Group")} name="groups">
          <Select mode="multiple" placeholder={t("ISMS.Select")} maxTagCount={"responsive"}>
            {groups.sort().map((group) => (
              <Option key={group} value={group}>
                {group}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item label={t("ISMS.Location")} name="city">
          <Select mode="multiple" placeholder={t("ISMS.Select")} maxTagCount={"responsive"}>
            {locations.map((location) => (
              <Option key={location} value={location}>
                {location}
              </Option>
            ))}
          </Select>
        </Form.Item> */}
      </Form>
    </div>
  );
};

export default FiledFilter;
